export const TRANSLATIONS_ESP = {
  username: "Nombre de usuario",
  password: "Contraseña",
  login: "INICIAR SESIÓN",
  registerMsg: "¿Aún no estás registrado?",
  registerMsg2: "Haz clic aquí",
  modalMsg: "Contraseña y/o nombre de usuario incorrectos",
};
